










































import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Button, Table, TableColumn, Scrollbar, Loading, Message, Row, Col,
} from 'element-ui';
import MyNav from '@/components/skeleton/topBack.vue'; // nav
import NProgress from 'nprogress';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import Study from '@/servers/modules/decisive/study'; // server

Vue.use(Loading.directive);
    @Component({
      components: {
        MyNav,
        Table,
        TableColumn,
        Scrollbar,
        Button,
        Row,
        Col,
      },
    })
export default class extends Vue {
// @ts-ignore
    @Getter public skeleton: any;

    // 切换展示
    // @ts-ignore
    @Getter public basicData: any;

    // 本地缓存基础数据-课程名称
    // @ts-ignore
    @Mutation public setSkeletonDescribe: any;

    private loading: boolean = true;

    type = false;

    // 展示数据源
    private data: any={ answeringTime: 0 };

    // 返回
    private back() {
      if (this.data.taskType == '弱项强化') {
        this.$router.replace({
          name: 'decisiveStudyReport',
          query: {
            classType: 2,
            select: 1,
          },
        });
      } else {
        this.$router.go(-1);
      }
    }
    // ==============================初始化=======================================

    private created() {
      this.setSkeletonDescribe(true);
      NProgress.start();
      this.init();
    }

    /**
     * 渲染时对应字段 枚举值
     *   nodeId 节点id
     *   processInstanceId 流程实例Id
     * */
    private async init() {
       const paper = Loading.service({ text: '生成试卷中' });
      // 保证 nodeId 必须存在否则回退页面
      if (this.$route.query.nodeId) {
        const form: any = {
          isRetraining: this.$route.query.isRetraining,
          nodeId: this.$route.query.nodeId,
          processDefinitionId: window.LS.get('jse_data').processDefinitionId,
          processInstanceId: window.LS.get('jse_data').processInstanceId,
          //   projectVerson: window.LS.get('jse_data').projectVerson,
          courseId: window.LS.get('basicData').courseId,
        };
        // 先获取缓存，判断是否为暂存进入学习。如果是，则暂存进入学习页面；如果不是，则展示当前阶段信息
        const resData = await Study.queryTemporaryStorage({});
        console.log('resData', resData, this.$route.query);
        if (!resData.data.code) {
          console.log();
          // 如果返回值有内容，则为暂存进入，设置路由参数isTemporaryStorage = 1，通知下个页面
          if (resData.data.data) {
            const queryForm:any = this.$route.query;
            queryForm.isTemporaryStorage = 1;
            form.isTemporaryStorage = 1;
            if (this.$route.query.paperAssemItemType) {
              form.paperAssemItemType = this.$route.query.paperAssemItemType;
            }
            const res = await Study.startLearning(form);
            this.data = res.data.data;
            console.log('resData', this.data);
            window.LS.set('jse_startstudy', this.data);
            this.$router.replace({ name: 'startLearningTest', query: queryForm });
          } else {
            const queryForm:any = this.$route.query;
            // 没有暂存内容--直接显示学习
            if (this.$route.query.paperAssemItemType) {
              form.paperAssemItemType = this.$route.query.paperAssemItemType;
            }
            const res = await Study.startLearning(form);
            this.data = res.data.data;
            console.log('resData', this.data);
            window.LS.set('jse_startstudy', this.data);
            if (res.data.data.itemList[0].itemTypeCode == 'E12A') {
              this.type = true;
            } else {
              this.type = false;
            }
            // 如果是拓展练习，不显示这个页面
            if (this.$route.query.isExit) {
              this.$router.replace({ name: 'startLearningTest', query: queryForm });
            }
          }
          NProgress.done();
          this.setSkeletonDescribe(false);
        }

        this.loading = false;
      } else {
        this.$router.go(-1);
      }
      paper.close()
    }
}
